import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
import { useTranslation } from 'next-i18next';
import Image from 'components/core/Image';
import styles from './index.module.scss';

export interface AddedToCartModalProps {
  visible: boolean;
  productName: string;
  productImage?: string;
  onClose: () => void;
  onCheckout: () => void;
}

const AddedToCartModal = ({ visible, productName, productImage, onClose, onCheckout }: AddedToCartModalProps) => {
  const { t } = useTranslation('card');

  return (
    <AnimatePresence>
      {visible && (
        <>
          <motion.div
            className={styles.overlay}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          >
            <motion.div
              className={styles.modal}
              role='dialog'
              aria-modal='true'
              onClick={(e: React.MouseEvent) => e.stopPropagation()}
              initial={{ opacity: 0, scale: 0.92, y: 12 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.92, y: 12 }}
              transition={{ duration: 0.2, ease: 'easeOut' }}
            >
              <button type='button' className={styles.close} onClick={onClose}>
                <X size={18} />
              </button>

              <div className={styles.iconWrap}>
                <CheckCircle2 size={28} />
              </div>

              <p className={styles.title}>{t('addedToCartTitle')}</p>

              <div className={styles.product}>
                {productImage && (
                  <div className={styles.productImg}>
                    <Image
                      src={productImage}
                      loader={() => productImage}
                      alt={productName}
                      width={56}
                      height={56}
                      unoptimized
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                  </div>
                )}
                <p className={styles.productName}>{productName}</p>
              </div>

              <div className={styles.actions}>
                <motion.button
                  type='button'
                  className={styles.checkoutBtn}
                  onClick={onCheckout}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.97 }}
                >
                  {t('checkoutBtn')}
                </motion.button>
                <button type='button' className={styles.continueBtn} onClick={onClose}>
                  {t('continueShoppingBtn')}
                </button>
              </div>
            </motion.div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default AddedToCartModal;
